module.exports = __webpack_public_path__ + "img/rating_half.4c33cf3d.svg";